import { render } from "./ImpersonateRevokeDialog.vue?vue&type=template&id=4b9a7166"
import script from "./ImpersonateRevokeDialog.vue?vue&type=script&lang=js"
export * from "./ImpersonateRevokeDialog.vue?vue&type=script&lang=js"

import "./ImpersonateRevokeDialog.vue?vue&type=style&index=0&id=4b9a7166&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__